import { db } from "./config.js";

export default {
  game(gameId) {
    return db.ref("games/" + gameId);
  },
  players(gameId) {
    return db.ref("games/" + gameId + "/players");
  },
  player(gameId, playerKey) {
    return db.ref("games/" + gameId + "/players/" + playerKey);
  },
  users() {
    return db.ref("users");
  },
  gameId(gameName) {
    return db.ref("gameIDs/" + gameName);
  },
  currentCard(gameId) {
    return db.ref("games/" + gameId + "/wordInfo/currentCard");
  },
  wordsInfo(gameId) {
    return db.ref("games/" + gameId + "/wordInfo");
  },
  currentPlayer(gameId) {
    return db.ref("games/" + gameId + "/playerInfo/currentPlayer");
  },
  playerInfo(gameId) {
    return db.ref("games/" + gameId + "/playerInfo");
  },
  currentTurnWords(gameId) {
    return db.ref("games/" + gameId + "/currentTurn");
  },
  gameConfigs(gameId) {
    return db.ref("games/" + gameId + "/gameConfigs");
  },
  timer(gameId) {
    return db.ref("games/" + gameId + "/turnTimer");
  },
  roundCount(gameId) {
    return db.ref("games/" + gameId + "/roundCount");
  },
  state(gameId) {
    return db.ref("games/" + gameId + "/state");
  },
};
